import { render, staticRenderFns } from "./PopUpNotifyFile.vue?vue&type=template&id=24629e29&"
import script from "./PopUpNotifyFile.vue?vue&type=script&lang=js&"
export * from "./PopUpNotifyFile.vue?vue&type=script&lang=js&"
import style0 from "./PopUpNotifyFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24629e29')) {
      api.createRecord('24629e29', component.options)
    } else {
      api.reload('24629e29', component.options)
    }
    module.hot.accept("./PopUpNotifyFile.vue?vue&type=template&id=24629e29&", function () {
      api.rerender('24629e29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpNotifyFile.vue"
export default component.exports